import React from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { BoatDetailsState } from '../boatList/BoatDetails';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { replaceAll } from '../boatList/boatListSlice';
import { analyticsService } from '../../services/AnalyticsService';

export function Import() {
  const dispatch: AppDispatch = useDispatch();

  const [importJson, setImportJson] = React.useState<string>('');

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    console.log('Import.handleInputChange', event);
    const value = event.target.value;
    setImportJson(value);
  }

  function handleImport() {
    try {
      const boatDetails: BoatDetailsState = JSON.parse(importJson);
      // TODO validate this structure does indeed match the shape of the interface
      // TODO do we need to do cutover here in case an olf file is pasted in?
      if (window.confirm(`Replace with this boat list ${JSON.stringify(boatDetails, undefined, 2)}`)) {
        dispatch(replaceAll(boatDetails));

        // Track successful data import
        analyticsService.logEvent('data_import', {
          source_type: 'json',
          record_count: boatDetails.boatGroupList?.reduce((total, group) => total + (group.boatDetails?.length || 0), 0) || 0,
          import_success: true,
          feature_name: 'import_container',
        });
      } else {
        // Track import cancellation
        analyticsService.logEvent('data_import', {
          source_type: 'json',
          record_count: boatDetails.boatGroupList?.reduce((total, group) => total + (group.boatDetails?.length || 0), 0) || 0,
          import_success: false,
          error_type: 'user_cancelled',
          feature_name: 'import_container',
        });
      }
    } catch (error) {
      console.error('Error parsing', importJson, error);
      window.alert(`Error parsing import data ${error}`);

      // Track import error
      analyticsService.logEvent('data_import', {
        source_type: 'json',
        record_count: 0,
        import_success: false,
        error_type: 'parse_error',
        feature_name: 'import_container',
      });
    }
  }

  return <Container>
    <h1 className="header">Import Boat List</h1>
    <Form>
      <Form.Control as="textarea" rows={10} value={importJson} onChange={handleInputChange} />
    </Form>
    <Button variant="primary" onClick={handleImport}>Import</Button>

  </Container>;
}
